import React from 'react';
export function ProblemSection() {
  return <section className="bg-[#1a1a2e] text-white py-10 md:py-14 px-4" data-id="element-112">
      <div className="max-w-2xl mx-auto text-center" data-id="element-113">
        <h2 className="text-2xl md:text-3xl font-black mb-4 font-['Oswald'] uppercase" data-id="element-114">
          Hoy en día, muchos niños no quieren estudiar…
        </h2>

        <p className="text-lg text-gray-300 mb-2" data-id="element-115">No porque no puedan.</p>
        <p className="text-xl text-white font-bold mb-5" data-id="element-116">
          Sino porque están aburridos.
        </p>

        <p className="text-base text-gray-400 mb-6 max-w-md mx-auto" data-id="element-117">
          Pantallas, distracciones, falta de motivación… Y al final, estudiar se
          convierte en una pelea diaria.
        </p>

        <div className="bg-white/10 rounded-xl p-5 max-w-md mx-auto" data-id="element-118">
          <p className="text-lg text-yellow-400 font-bold mb-2" data-id="element-119">
            👉 Como padre, eso frustra.
          </p>
          <p className="text-base text-gray-300" data-id="element-120">
            Quieres que aprenda… pero también quieres verlo disfrutar.
          </p>
        </div>
      </div>
    </section>;
}